export const AUTOMATIC_ANSWERS_NODES = {
  1: {
    nodeName: "Marca",
    level: 1,
    config:[]
  },
  2: {
    nodeName: "Marca / Zona",
    level: 2,
    config:[]
  },
  3: {
    nodeName: "Marca / Zona",
    level: 3,
    config:[]
  },
  9: {
    nodeName: "Negocio",
    level: 9,
    config:[]
  }
}